import { render, staticRenderFns } from "./OnboardPartnerModal.vue?vue&type=template&id=51780c14&scoped=true"
import script from "./OnboardPartnerModal.vue?vue&type=script&lang=js"
export * from "./OnboardPartnerModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardPartnerModal.vue?vue&type=style&index=0&id=51780c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51780c14",
  null
  
)

export default component.exports